import { Types } from "@grandvisionhq/graphql";
import { getLocalizedStrings } from "@grandvisionhq/utils";
import { getEyeSide } from "../../../../../../utils/utils/get-eye-side.js";
import { toBaseLineItem } from "./base-line-item.js";
import { getContactLensA11yLabel } from "../../../utils/mappers/view/visual-line-item/utils/get-product-a11y-label.js";
import { getAttribute } from "../../../../../../utils/utils/get-line-item-attribute.js";
import { getLocalizedAttribute } from "../../../../../../utils/utils/get-line-item-localized-attribute.js";
import { getProductTitle } from "../../../utils/mappers/view/visual-line-item/utils/get-product-title.js";
import { getLineItemAvailability } from "../../../../../../utils/utils/get-line-item-availability.js";
import { getLineItemImageUrl } from "../../../../../../utils/utils/get-line-item-image-url.js";
const toEyeSideLabelKey = (eyeSide) => {
  switch (eyeSide?.toUpperCase()) {
    case Types.EyeSide.LEFT:
      return "products.contactLenses.leftEye";
    case Types.EyeSide.RIGHT:
      return "products.contactLenses.rightEye";
    case Types.EyeSide.BOTH:
    default:
      return void 0;
  }
};
const toEyeSide = (eyeSide) => {
  switch (eyeSide) {
    case "left":
      return "left";
    case "right":
      return "right";
    case "both":
      return "both";
    default:
      return void 0;
  }
};
const toEyePrescription = (prescriptionData) => {
  return {
    addition: prescriptionData.addition?.toString(),
    axis: prescriptionData.axis?.toString(),
    baseCurve: prescriptionData.baseCurve?.toString(),
    cylinder: prescriptionData.cylinder?.toString(),
    power: prescriptionData.power?.toString(),
    diameter: prescriptionData.diameter?.toString(),
    dominance: prescriptionData.dominance
  };
};
const toContactLensesCartLineItem = (cartLineItem, intl, settings, apiUrl) => {
  const variant = cartLineItem.legacyProduct.masterData.current.variant;
  const eyeSide = toEyeSide(getEyeSide(cartLineItem.typeDetails));
  const eyeSideLabelKey = eyeSide !== "both" ? toEyeSideLabelKey(eyeSide) : void 0;
  const eyeSideLabel = eyeSideLabelKey ? `${intl.getLabel(eyeSideLabelKey)},` : void 0;
  const packageQuantity = getAttribute(variant, "packageQuantity");
  const replacementFrequency = getLocalizedAttribute(variant, "replacementFrequency", intl.locale);
  const unit = intl.getLabel("products.unit.contactLenses");
  const subtitle = [eyeSideLabel, packageQuantity, replacementFrequency, unit].filter(Boolean).join(" ");
  const prescription = toEyePrescription(cartLineItem.typeDetails.prescriptionData);
  const title = getProductTitle(cartLineItem.legacyProduct, intl);
  const colorValues = getLocalizedStrings(cartLineItem.typeDetails.colors, intl.locale);
  const colorLabel = `${intl.getLabel("products.lensColor")}: ${colorValues.join(", ")}`;
  return {
    ...toBaseLineItem(cartLineItem, settings, intl),
    productType: "contact-lenses",
    title,
    eyeSide,
    prescription,
    type: "CONTACT_LENSES",
    subtitle,
    imageUrl: getLineItemImageUrl(variant),
    altText: prescription ? getContactLensA11yLabel(prescription, intl, title, eyeSideLabel) : title,
    ...variant.availability ? { availability: getLineItemAvailability(variant.availability) } : {},
    quoteConfig: cartLineItem?.quote?.quoteToken ? {
      quoteUrl: `${apiUrl}/quotes/${cartLineItem.quote.quoteToken}`,
      hasQuoteLink: Boolean(settings.shouldShowQuoteLink)
    } : void 0,
    additionalInfo: colorValues.length ? [colorLabel] : void 0
  };
};
export {
  toContactLensesCartLineItem,
  toEyePrescription
};
//# sourceMappingURL=contact-lenses-line-item.js.map
